export default __webpack_public_path__ + "static/media/Group 2.1c19d521.svg";